import SearchAnything from './SearchAnything';
export default SearchAnything;